import { render, staticRenderFns } from "./VueWindowPortal.vue?vue&type=template&id=b16e4c3a&"
import script from "./VueWindowPortal.vue?vue&type=script&lang=js&"
export * from "./VueWindowPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports